module.exports = __webpack_public_path__ + "assets/img/1efbd36e94fb28928b718567de588a33.svg";